import { UserApiUserUpdateEmailVerifyRequest } from '../../openapi/api'
import appApiClient from './appApiClient'
import useBaseMutation from './useBaseMutation'

export const useUserUpdateEmailVerifyMutation = () =>
  useBaseMutation({
    mutationFn: (req: UserApiUserUpdateEmailVerifyRequest, config) =>
      appApiClient.userApi.userUpdateEmailVerify(req, config),
  })
